import React from 'react';
import { Navigate } from 'react-router-dom';
import { useCurrentUser } from '../../hooks/useCurrentUser';

// ============================================================================
// Smart redirect component (moved from App.tsx). A user whose brand is
// onboarding never reaches it: ProtectedRoute sends them to /onboarding first.
// ============================================================================

const RootRedirect: React.FC = () => {
  const { user, loading } = useCurrentUser();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  if (user?.role === 'SUPER_ADMIN' || user?.role === 'ADMIN') {
    return <Navigate to="/admin/dashboard" replace />;
  }
  if (user?.role === 'FINANCE') {
    return <Navigate to="/reports" replace />;
  }
  return <Navigate to="/portal/total?tab=overview" replace />;
};

export default RootRedirect;
